import { TypeDept } from './type.dept';
import { CriteresIndexationHelper } from '../helpers/CriteresIndexationHelper';
import {TypeMotsClef} from './TypeMotsClef';
export class TypeIndexation {
  public dateFinDiffusion: Date;
  public objetAvis = '';
  public nomOrganisme = '';
  public criteresSociaux: string = CriteresIndexationHelper.CRITERE_DEFAUT;
  public criteresEnvironnementaux: string = CriteresIndexationHelper.CRITERE_DEFAUT;
  public motsClef: TypeMotsClef = new TypeMotsClef();
  public deptPublication: TypeDept = new TypeDept();
}
